import React from 'react';
import ProofHeader from '../../pages/proof-detail-view/components/ProofHeader';
import ProofImageViewer from '../../pages/proof-detail-view/components/ProofImageViewer';
import ProofMetadata from '../../pages/proof-detail-view/components/ProofMetadata';

const ProofDetailModal = ({
  isOpen,
  proofs,
  activeIndex,
  onClose,
  onPrev,
  onNext,
  hasPrev,
  hasNext,
}) => {
  const active = proofs?.[activeIndex];
  if (!isOpen || !active) return null;

  return (
    <div className="fixed inset-0 z-dialog bg-background/80 flex items-center justify-center p-4" onClick={onClose}>
      <div className="w-full max-w-4xl" onClick={(e) => e?.stopPropagation()}>
        <div className="bg-card rounded-lg shadow-gaming-lg p-4 md:p-6 lg:p-8">
          <ProofHeader
            currentProof={activeIndex + 1}
            totalProofs={proofs?.length}
            challengeTitle={active?.challengeName}
            onClose={onClose}
          />

          <div className="space-y-6 md:space-y-8">
            <ProofImageViewer
              imageUrl={active?.image}
              imageAlt={active?.imageAlt}
              onPrevious={onPrev}
              onNext={onNext}
              hasPrevious={hasPrev}
              hasNext={hasNext}
            />

            <ProofMetadata
              submissionDate={active?.submittedAt}
              starRating={active?.stars}
              description={active?.description}
              youtubeUrl={active?.youtubeUrl || ''}
            />

            <div className="flex justify-end">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 rounded-md bg-muted/40 text-foreground hover:bg-muted transition-gaming"
              >
                닫기
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProofDetailModal;
